import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

const Appqr = () => {
    const handleDownload = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
        // Google Play Store link
        window.location.href =
            "https://play.google.com/store/apps/details?id=com.yourfriend.myfriend";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // Apple App Store link
        window.location.href =
            "https://apps.apple.com/us/app/your-friend-my-friend/id6748553590";
        } else {
        // Desktop users
        window.location.href = "https://yourfriendmyfriend.ie/";
        }
    };

    return (
        <>
            <div
                className="coidar_qr_container_main"
                style={{ willChange: "background", backgroundColor: "rgb(255, 255, 255)" }}
            >
                <div className="coidar_qr_text_main">
                   Download <br /> the YFMF App 
                </div>
                <div className="coidar_qr_div_main"></div>
            </div>


            <div
                className="coidar_qr_container_main3"
                style={{ willChange: "background", backgroundColor: "rgb(211 252 160)" }}
            >
                <Link to="/upcoming-events" className="coidar_qr_text_main text-decoration-none">

                   Browse Events <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'} alt="arrow" className="arrow ms-1" />
                </Link>
            </div>
            <div
                className="coidar_qr_container_main2"
                style={{ willChange: "background", backgroundColor: "rgb(255, 255, 255)" }}
                onClick={handleDownload}
            >
                <div className="coidar_qr_text_main">
                   Download App <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'} alt="arrow" className="arrow ms-1" />
                </div>
            </div>
        </>
    );
};

export default Appqr;
